import { render, staticRenderFns } from "./alertBox.vue?vue&type=template&id=c65d3d18&scoped=true&"
import script from "./alertBox.vue?vue&type=script&lang=js&"
export * from "./alertBox.vue?vue&type=script&lang=js&"
import style0 from "./alertBox.vue?vue&type=style&index=0&id=c65d3d18&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65d3d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
